<template>
  <section class="section-promo-code">
    <!-- Discount with appling promo code -->
    <div class="pt-3">
      <div v-if="!appliedPromoCode && (preBookingData && !preBookingData.package_type)">
        <div class="d-flex pointer-item" role="button" @click="openMyPromoCodeModal()">
          <div class="flex-fill">
            <i class="fal fa-ticket text-orange fa-lg"></i> {{ $t('message.booking.payment_step.promo_code') }}
          </div>
          <div class="flex-fill text-right text-black-50">
            {{ $t('message.booking.payment_step.select_promo_code') }} <i class="fal fa-angle-right"></i>
          </div>
        </div>
      </div>
      <div class="p-0" v-if="appliedPromoCode">
        <i class="fas fa-exclamation-triangle -status-alert" v-if="!appliedPromoCode.is_applied"></i>
        <a href="" class="no-style" @click.prevent="displayPromoCodeDetailDialog()">
          {{ $t('message.booking.summary.discount') }}: {{ appliedPromoCode.promo_code.code }} ({{ appliedPromoCode.discount }}%)
        </a>
        <a href=""
           class="no-style"
           @click.prevent="displayCancelPromoCodeDialog()"
           v-if="preBookingData && !preBookingData.subscription_type_id && !preBookingData.package_type && appliedPromoCode.promo_code.code_type !== 'new_prof'">
          <i class="fas fa-times"></i>
        </a>
      </div>
      <!-- <div class="text-remark">({{ $t('message.booking.summary.discount_before_vat') }})</div> -->
    </div>
    <!-- Discount with using coin (credit) -->
    <div class="wallet_credit mt-3" v-if="preCheckoutData">
      <hr>
      <div class="">
        <div class="row no-gutters">
          <div class="col-10">
            {{ $t('message.booking.summary.my_credits') }}: <strong>{{ preCheckoutData.total_credits | currency }}</strong>
            <!-- <div class="text-remark">({{ $t('message.booking.summary.discount_after_vat') }})</div> -->
          </div>
          <div class="col-2 text-right">
            <toggle-button v-model="preCheckoutData.is_credit"
                           :sync="true"
                           :disabled="checkIsCreditAvailable()"
                           color="#FFC107"/>
          </div>
          <div v-if="appliedPromoCode && appliedPromoCode.promo_code.is_credit_available === 0"
               class="-status-alert text-remark py-2">
            <i class="fas fa-exclamation-triangle -status-alert"></i> {{
            $t('message.booking.checkout_step.cannot_use_coins_with_promo_code') }}
          </div>
        </div>
        <div class="row no-gutters text-remark mt-2">
          <div class="col-8">{{ $t('message.booking.checkout_step.invite_friends') }}</div>
          <div class="col-4 text-right">
            <a href="#" class="text-primary-link" @click.prevent="openInviteFriendModal()">{{
              $t('message.home.see_detail_button') }}</a>
          </div>
        </div>
      </div>
    </div>
    <invite-friend-modal ref="inviteFriendModal"></invite-friend-modal>
    <my-promo-code-modal ref="myPromoCodeModal"
                         :searchParams="searchParams"
                         @onSelected="selectPromoCode"></my-promo-code-modal>
    <promo-code-detail-modal ref="promoCodeDetailModal"></promo-code-detail-modal>
    <snackbar ref="snackbar"
              baseSize="100px"
              :colors="{open: '#333', info: '#3DBD7D', error: '#FA7377', warn: '#FF6600'}"
              :holdTime="2500"
              :position="'bottom-center'"/>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import packageHelpers from '../../../helpers/packageHelpers'
  import InviteFriendModal from './InviteFriendModal'
  import MyPromoCodeModal from './MyPromoCodeModal'
  import PromoCodeDetailModal from './PromoCodeDetailModal'

  export default {
    props: {
      creditDiscountCost: Number,
      totalPrice: Number
    },
    components: {
      InviteFriendModal,
      MyPromoCodeModal,
      PromoCodeDetailModal
    },
    data () {
      return {
        promoCode: null,
        province_id: '',
        isCredit: false,
        searchParams: null
      }
    },
    computed: {
      ...mapState('chatBooking', ['partner']),
      ...mapGetters({
        appliedPromoCode: 'promoCode/getAppliedPromoCode',
        preBookingData: 'booking/getPreBookingData',
        preCheckoutData: 'booking/getPreCheckoutData',
        state: 'promoCode/getState',
        user: 'auth/getUser'
      })
    },
    watch: {
      promoCode () {
        this.$store.commit('promoCode/SET_PROMO_CODE_VALUE', this.promoCode)
      },
      isCredit () {
        const data = {
          key: 'is_credit',
          value: this.isCredit
        }
        alert('is_credit:' + this.isCredit)
        this.$store.commit('booking/UPDATE_PRE_CHECKOUT_DATA', data)
      }
    },
    methods: {
      openMyPromoCodeModal () {
        this.$refs.myPromoCodeModal.showMyPromoCodeModal(true)
      },
      openInviteFriendModal () {
        this.$refs.inviteFriendModal.showInviteFriendModal(true)
      },
      checkIsCreditAvailable () {
        let disable = false
        if (this.appliedPromoCode && this.appliedPromoCode.promo_code.is_credit_available === 0) {
          this.$store.commit('booking/UPDATE_PRE_CHECKOUT_DATA', {
            key: 'is_credit',
            value: false
          })
          disable = true
        }
        if (this.preCheckoutData && this.preCheckoutData.total_credits <= 0) {
          disable = true
        }
        return disable
      },
      isUnlimitedPackageWithoutDiscount () {
        if (this.preBookingData.package_type.category === 'unlimited') {
          const numDates = this.preBookingData.multi_dates_times.length
          const packageTypeDiscount = packageHelpers.getUnlimitedPackageDiscount(this.preBookingData.package_type, numDates)
          if (packageTypeDiscount) {
            return false
          } else {
            return true
          }
        }
        return false
      },
      selectPromoCode (promoCode) {
        if (this.totalPrice) {
          this.promoCode = promoCode.code
          this.applyPromoCode()
        }
      },
      applyPromoCode () {
        if (!this.promoCode) {
          this.$refs.promoCode.focus()
        } else {
          const submitData = {
            user_id: this.user.id,
            promo_code: this.promoCode,
            province_id: this.preBookingData.province_id,
            service_id: this.preBookingData.service_id,
            work_hour: this.preBookingData.work_hour,
            payment_method: (this.preCheckoutData && this.preCheckoutData.payment_method) ? this.preCheckoutData.payment_method : null,
            omise_customer_id: (this.preCheckoutData && this.preCheckoutData.omise_customer_id) ? this.preCheckoutData.omise_customer_id : null
          }
          if (this.partner) {
            submitData.partner_id = this.partner.id
          }
          // Check partner referral code of chat booking
          const queryParams = this.$route.query
          if (queryParams.ref) {
            submitData.partner_referral_code = queryParams.ref
          }
          // Check service items
          if (this.preBookingData && this.preBookingData.service_items) {
            const serviceItems = []
            this.preBookingData.service_items.forEach(item => {
              serviceItems.push({ id: item.id, quantity: item.count })
            })
            submitData.service_items = serviceItems
          }
          this.$store.dispatch('promoCode/APPLY_PROMO_CODE', submitData)
        }
      },
      displaySnackbar (message) {
        this.$refs.snackbar.open(message)
      },
      displayPromoCodeDetailDialog () {
        this.$refs.promoCodeDetailModal.showModal(true)
      },
      displayCancelPromoCodeDialog () {
        this.$swal({
          text: this.$i18n.t('message.alert.cancel_promo_code'),
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonColor: '#17a2b8',
          confirmButtonText: this.$i18n.t('message.button.cancel_current_promo_code'),
          cancelButtonText: this.$i18n.t('message.button.use_current_promo_code')
        }).then((result) => {
          if (result) {
            this.displaySnackbar(this.$i18n.t('message.promo_code.cancel_current_promo_code_alert'))
            this.$store.commit('promoCode/SET_APPLIED_PROMO_CODE', null)
          }
        })
      }
    },
    mounted () {
      this.$store.commit('promoCode/SET_APPLYING_PROMO_CODE', false)
      // Set searchParams for searching promo code
      if (this.preBookingData) {
        this.searchParams = {
          province_id: this.preBookingData.province_id,
          service_id: this.preBookingData.service_id,
          work_hour: this.preBookingData.work_hour
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/PromoCode.vue